import { createFileRoute } from "@tanstack/react-router";

import { LoginPage } from "@/auth";
import { redirectIfAuthed } from "@/auth/session";
import { pageTitle } from "@/i18n/title";

export const Route = createFileRoute("/login")({
  beforeLoad: ({ context }) => redirectIfAuthed(context.queryClient),
  head: () => pageTitle("Sign in"),
  component: LoginPage,
});
